/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompletedIntervalDTO
 */
export interface CompletedIntervalDTO {
    /**
     * 
     * @type {number}
     * @memberof CompletedIntervalDTO
     */
    completedPrimaryTime: number;
    /**
     * 
     * @type {number}
     * @memberof CompletedIntervalDTO
     */
    completedSecondaryTime?: number;
}

/**
 * Check if a given object implements the CompletedIntervalDTO interface.
 */
export function instanceOfCompletedIntervalDTO(value: object): value is CompletedIntervalDTO {
    if (!('completedPrimaryTime' in value) || value['completedPrimaryTime'] === undefined) return false;
    return true;
}

export function CompletedIntervalDTOFromJSON(json: any): CompletedIntervalDTO {
    return CompletedIntervalDTOFromJSONTyped(json, false);
}

export function CompletedIntervalDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompletedIntervalDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'completedPrimaryTime': json['completedPrimaryTime'],
        'completedSecondaryTime': json['completedSecondaryTime'] == null ? undefined : json['completedSecondaryTime'],
    };
}

export function CompletedIntervalDTOToJSON(json: any): CompletedIntervalDTO {
    return CompletedIntervalDTOToJSONTyped(json, false);
}

export function CompletedIntervalDTOToJSONTyped(value?: CompletedIntervalDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'completedPrimaryTime': value['completedPrimaryTime'],
        'completedSecondaryTime': value['completedSecondaryTime'],
    };
}

